import apiClient from '../lib/axios';
import type { User } from '../contexts/AuthContext';

export interface SignupInput {
  email: string;
  password: string;
  fullName: string;
}

export async function signup(input: SignupInput): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/signup', input);
  return data;
}

export async function verifyEmail(token: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/verify-email', { token });
  return data;
}

export async function resendVerification(email: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/auth/resend-verification', { email });
  return data;
}

export interface GoogleAuthResponse {
  accessToken: string;
  user: User;
}

export async function googleAuth(idToken: string): Promise<GoogleAuthResponse> {
  const { data } = await apiClient.post<GoogleAuthResponse>('/auth/google', { idToken });
  return data;
}
